<template>
  <div id="app" :class="{ isWeb: isWeb }">
    <router-view class="router-view" />
    <div
      class="foot"
      v-if="isWeb && screenHeight > 700 && $store.state.appid != 'tnas'"
    >
      <font>@2022 版权所有 深圳市玩物科技有限公司</font>
      <a
        class="beian"
        href="http://www.beian.miit.gov.cn"
        target="_blank"
        title="粤ICP备18147482号-1"
        >粤ICP备18147482号-1</a
      >
      <a
        class="gongan"
        target="_blank"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502004455"
        title="粤公网安备 44030502004455号"
        >粤公网安备 44030502004455号</a
      >
    </div>

    <Version v-if="isShowVersion"></Version>
    <Toast :msg="$store.state.toast" v-if="$store.state.toast"></Toast>
  </div>
</template>

<script>
import Version from "@/components/Common/Version.vue";
import Toast from "@/components/Common/Toast.vue";
import { mapActions, mapMutations } from "vuex";
import req from "./req/index";
export default {
  data: function () {
    return {
      isShowVersion: false,
      isWeb: true,
      screenHeight: 999,
    };
  },
  components: {
    Version,
    Toast,
  },
  watch: {
    "$store.state.toast": function (newVal) {
      let _that = this;
      // console.log("$store.state.toast", newVal);
      if (newVal) {
        setTimeout(function () {
          _that.$store.state.toast = "";
        }, 3000);
      }
    },
  },
  methods: {
    ...mapActions([
      "sendUserlog",
      "getPidByMacSn",
      "statAlive",
      "setUserImagebackupPath",
    ]),
    ...mapMutations(["setUser", "setClient", "setVersion", "setAppid"]),
    ua: function () {
      let _that = this;
      let client = _that.$route.query.client
        ? _that.$route.query.client
        : localStorage.getItem("jdxb-client");

      client = client ? client : "web";
      _that.$common.localStorage.setItem("jdxb-client", client);
      if (client == "windows" || client == "mac") {
        _that.isWeb = false;
      }
      if (client == "windows") {
        req.updateHttp();
      }
      _that.setClient(client);
      let version = _that.$route.query.version
        ? _that.$route.query.version
        : localStorage.getItem("jdxb-ver");
      version = version ? version : "";
      _that.$common.localStorage.setItem("jdxb-ver", version);
      _that.setVersion(version);

      if (client == "windows" || client == "mac") {
        _that.checkVersion();

        if (_that.$store.state.version > "2.3.2") {
          _that.getLocalPid();
          _that.startHttpd();
        }

        // if (_that.$store.state.client == "mac") {
        // 	window.webkit.messageHandlers.getUUID &&
        // 		window.webkit.messageHandlers.getUUID.postMessage({
        // 			cb: "getUUIDCallback",
        // 		});
        // }
        _that.checkFirstTime();
      }

      _that.$store.state.client_info.isIE =
        navigator.appName == "Microsoft Internet Explorer";
      _that.$store.state.client_info.isChrome =
        navigator.userAgent.indexOf("Chrome") > -1;
      _that.$store.state.client_info.ieVersion = _that.getIEVersion();
      if (
        _that.$store.state.client_info.ieVersion < 10 &&
        _that.$store.state.client_info.ieVersion > 0
      ) {
        req.updateToSameSiteApi();
      }

      _that.sendUserlog(["open", window.location.href]);
      _that.sendUserlog(["useragent", navigator.userAgent]);

      // mac sn 转 pid
      let mac = _that.$route.query.mac ? _that.$route.query.mac : "";
      let sn = _that.$route.query.sn ? _that.$route.query.sn : "";
      let appid = _that.$route.query.appid
        ? _that.$route.query.appid
        : localStorage.getItem("jdxb-appid");
      _that.$common.localStorage.setItem("jdxb-appid", appid);
      let pid = _that.$route.query.pid ? _that.$route.query.pid : "";
      let pidInfo = _that.getInfoFromPid(pid);

      // 测速网手机打开跳转到wap页面
      if (!appid && pidInfo.cid == 134) {
        appid = "Speedtest";
      }
      if (appid == "Speedtest" && _that.isMobile()) {
        let url =
          "https://yc.ionewu.com/jdxb_app/?appid=" +
          appid +
          "&sn=" +
          sn +
          "&mac=" +
          mac +
          "&pid=" +
          pid;
        window.location.href = url;
        return;
      }
      _that.setAppid(appid);
      if (appid && (sn || mac)) {
        _that.loginWithSnAndMac(appid, sn, mac);
      }
    },

    isMobile: function () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag ? true : false;
    },

    getIEVersion: function () {
      var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      var isIE =
        userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
      var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
      var isIE11 =
        userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
      if (isIE) {
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp["$1"]);
        if (fIEVersion == 7) {
          return 7;
        } else if (fIEVersion == 8) {
          return 8;
        } else if (fIEVersion == 9) {
          return 9;
        } else if (fIEVersion == 10) {
          return 10;
        } else {
          return 6; //IE版本<=7
        }
      } else if (isEdge) {
        return "edge"; //edge
      } else if (isIE11) {
        return 11; //IE11
      } else {
        return -1; //不是ie浏览器
      }
    },

    loginWithSnAndMac: function (appid, sn, mac) {
      let _that = this;
      let pid = "";
      sn = decodeURIComponent(sn).toUpperCase();
      mac = decodeURIComponent(mac);
      mac = mac.replace(/:/g, "").toUpperCase();
      if (sn || mac) {
        _that.getPidByMacSn([
          appid,
          mac,
          sn,
          function (err, data) {
            if (!err && data.pid && data.rtn == 0) {
              pid = data.pid;
              _that.$router.push({
                path: "/",
                query: {
                  pid: pid,
                },
              });
            }
          },
        ]);
      }
    },

    getInfoFromPid: function (pid) {
      let data = {
        cid: 0, // 厂商ID
        did: 0, // 设备ID
      };
      if (pid.length > 6) {
        if (pid.substr(-2, 2).toLowerCase() == "ow") {
          data.cid = parseInt(pid.substr(-6, 2), 16);
          data.did = parseInt(pid.substr(-4, 2), 16);
        }
      }
      if (isNaN(data.cid)) {
        data.cid = 0;
      }
      if (isNaN(data.did)) {
        data.did = 0;
      }
      return data;
    },

    checkVersion: function () {
      if (
        this.$store.state.client == "windows" &&
        this.$store.state.version < this.$store.state.mini_windows_version
      ) {
        this.isShowVersion = true;
      } else {
        this.isShowVersion = false;
      }
    },

    doAlive: function () {
      let _that = this;
      // _that.sendUserlog(["statAliveBefore", _that.$store.state.local_pid]);
      _that.statAlive([
        function (err, data) {
          // alert(JSON.stringify(data));
          // console.log(data);
          let next = 30 * 60 * 1000;
          if (data.next) {
            next = data.next * 1000;
          }
          setTimeout(function () {
            _that.doAlive();
          }, next);
          _that.sendUserlog([
            "statAlive",
            _that.$store.state.local_pid + JSON.stringify(data),
          ]);
        },
      ]);
    },

    getLocalPid: function () {
      let _that = this;

      if (_that.$store.state.client == "windows") {
        _that.$store.state.local_pid =
          window.external && window.external.getLocalPid
            ? window.external.getLocalPid()
            : _that.$store.state.local_pid;

        _that.$store.state.hostname =
          window.external && window.external.getHostName
            ? window.external.getHostName()
            : _that.$store.state.hostname;

        _that.doAfterGetPid();

        _that.sendUserlog(["local_pid", _that.$store.state.local_pid]);
      } else if (_that.$store.state.client == "mac") {
        window.webkit &&
          window.webkit.messageHandlers.getUUID &&
          window.webkit.messageHandlers.getUUID.postMessage({
            cb: "getUUIDCallback",
          });
        window.webkit &&
          window.webkit.messageHandlers.getHostName &&
          window.webkit.messageHandlers.getHostName.postMessage({
            cb: "getHostNameCallback",
          });
      } else {
        _that.doAfterGetPid();
      }
    },
    getMacByPid: function (pid) {
      return pid.substring(0, pid.length - 6);
    },

    doAfterGetPid: function () {
      let _that = this;

      // for test
      // _that.$store.state.pid = "08606E593932636BOW";
      // _that.$store.state.hostname = "test";

      if (!_that.$store.state.local_pid) {
        console.log("获取设备信息失败" + _that.$store.state.local_pid);
        return;
      }
      // _that.$store.state.mac = _that.getMacByPid(_that.$store.state.local_pid);
      if (
        _that.$store.state.client == "windows" ||
        _that.$store.state.client == "mac"
      ) {
        _that.doAlive();
      }
    },

    startHttpd: function () {
      let _that = this;
      if (_that.$store.state.client == "windows") {
        let imagebackPath =
          window.external &&
          window.external.getImagebackupPath &&
          window.external.getImagebackupPath
            ? window.external.getImagebackupPath()
            : "";
        if (!imagebackPath) {
          imagebackPath =
            window.external &&
            window.external.getAppPath &&
            window.external.getAppPath
              ? window.external.getAppPath() + "\\images"
              : "C:/backup";
        }
        imagebackPath = imagebackPath.replace(/\\/g, "/");
        imagebackPath = imagebackPath.replace(/\/ /g, "\\ ");
        _that.setUserImagebackupPath([imagebackPath]);
        window.external &&
          window.external.startHttpd &&
          window.external.startHttpd("httpd.exe", 6361, imagebackPath);
      } else if (_that.$store.state.client == "mac") {
        if (window.webkit && window.webkit.messageHandlers.getImagebackupPath) {
          window.webkit.messageHandlers.getImagebackupPath.postMessage({
            cb: "getImagebackupPathCallbackApp",
          });
        }
      } else if (_that.$store.state.client == "qh") {
        let imagebackPath = "<共享路径>/OWSpeedup/photos";
        _that.setUserImagebackupPath([imagebackPath]);
      } else if (_that.$store.state.client == "tnas") {
        let imagebackPath = "<共享路径>/OWSpeedup/OWData/photos";
        _that.setUserImagebackupPath([imagebackPath]);
      } else if (_that.$store.state.client == "qnap") {
        let imagebackPath = "<共享路径>/OWSpeedup/photos";
        _that.setUserImagebackupPath([imagebackPath]);
      }
    },
    checkFirstTime: function () {
      let _that = this;
      if (_that.$store.getters.isAppstoreMode) {
        return;
      }
      let isFirstTime = localStorage.getItem("jdxb-first-time");
      // console.log("isFirstTime", isFirstTime);
      isFirstTime = isFirstTime ? false : true;

      // for test
      isFirstTime = false;

      if (isFirstTime) {
        localStorage.setItem("jdxb-first-time", true);
        window.location.href =
          "http://yc.iepose.com/jdxb_server_pc_v4/?client=" +
          _that.$store.state.client +
          "&version=" +
          _that.$store.state.version;
      }
    },
  },
  beforeMount: function () {
    let _that = this;
    // for test
    // localStorage.setItem("jdxb-uid", "445487");
    // localStorage.setItem("jdxb-owcode", "Ionewu-20220610-*1666~");

    _that.ua();
  },
  mounted() {
    // window.onresize = () => {
    // 	return (() => {
    // 		_that.screenHeight = document.body.clientHeight;
    // 	})();
    // };
    let _that = this;

    window.getUUIDCallback = function (data) {
      let uuid = data.uuid ? data.uuid : "";
      _that.$store.state.local_pid = uuid;
      _that.$store.state.uuid = uuid;
      window.webkit &&
        window.webkit.messageHandlers.initGlp2pServer &&
        window.webkit.messageHandlers.initGlp2pServer.postMessage({
          pid: _that.$store.state.uuid,
        });
      _that.doAfterGetPid();
      _that.sendUserlog(["local_pid", _that.$store.state.local_pid]);
    };

    window.getHostNameCallback = function (data) {
      let name = data.name ? data.name : "";
      _that.$store.state.hostname = name;
    };

    window.getImagebackupPathCallbackApp = function (data) {
      let imagebackPath = data.path;
      window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.startHttpd.postMessage({
          name: "httpd",
          port: 6361,
          path: imagebackPath,
        });
      _that.setUserImagebackupPath([imagebackPath]);
    };
  },
};
</script>
<style lang="less">
* {
  padding: 0;
  margin: 0;
  border: 0;
  outline: 0;
}

html,
body,
#app {
  width: 100%;
  height: 100%;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

::-webkit-scrollbar {
  width: 0;
}

/*去掉IE11的叉叉*/
input::-ms-clear,
select::-ms-expand {
  display: none;
}

#app {
  min-width: 980px;
  min-height: 612px;
  font-family: "Microsoft Yahei", "微软雅黑", Avenir, Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Chrome/Safari/Opera */
  -khtml-user-select: none;
  /* Konqueror */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
not supported by any browser */
}

.isWeb {
  background-image: url("./assets/login/web_bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  overflow: hidden;

  .router-view {
    width: 980px;
    height: 615px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -490px;
    margin-top: -307px;
  }

  .foot {
    position: absolute;
    left: 0;
    bottom: 20px;
    display: block;
    color: #999999;
    text-align: center;
    width: 100%;
    font-size: 12px;
    font {
      margin-right: 10px;
    }
    a {
      color: #999999;
      margin-right: 10px;
    }
    .gongan {
      background-image: url(./assets/home/ga_icon.png);
      background-position: left center;
      background-repeat: no-repeat;
      background-size: 14px 15px;
      padding-left: 20px;
    }
  }
}

/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 5px;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
  display: none;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: rgba(160, 160, 160, 1);
}
</style>
